import { Route } from '@angular/router';
import { provideOrderDomain } from '@zero/order/domain';

export const ORDER_WEB_ROUTES: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/my-orders/my-orders.component').then((m) => m.MyOrdersComponent),
    providers: [provideOrderDomain()],
  },
];
